import { PayloadAction } from '@reduxjs/toolkit';

import { TourState } from 'editor/src/store/editorModules/tour/types';

const setIntroTourStepsReducer = (state: TourState, action: PayloadAction<TourState['introSteps']>) => {
  state.introSteps = action.payload;
};

export default setIntroTourStepsReducer;
